import { useState } from "react";
import MemberShipService from "../../services/MemberShipService"
import { MembershipViewModel } from "../../viewModels";
import MembershipList from "./ui/MembershipList";
import PricesSkeleton from "./skeletons/PricesSkeleton";

export default function PricesPage(){
    const api = new MemberShipService();
    const [memberships, setMemberships] = useState<MembershipViewModel[]>([]);
    const [loading,setLoading] = useState(true);
    useState(()=>{
        api.getMemberships().then(res => {
            setMemberships(res);
            setLoading(false);
        })
    })
    
    // update ui with a suitable price page that display description and a list of membership and each membership will display in card, memberships list can be display in a new component in ui folder
    return <main className="w-full flex justify-center items-center flex-1 ">
        <div className="container mx-auto px-4 py-16">
            <h1 className="text-4xl font-bold text-center text-purple-900 mb-12">Our Membership Plans</h1>
            <p className="text-lg text-gray-700 text-center mb-12 max-w-3xl mx-auto">
                Choose the plan that best fits your needs and start your journey to a calmer, more focused you. Each plan offers unique benefits designed to enhance your breathing practice.
            </p>
            {loading?<PricesSkeleton/>:
            <MembershipList memberships={memberships}/>}
            
        </div>
    </main>
   
}